export default __webpack_public_path__ + "static/certificatesHeader-7ac174f28ef01213f87463bf66b26422.jpg";